<template>
  <div>
    <div class="tw-flex tw-justify-center tw-items-center">
      <div v-if="!success" class="action-block">
        <button class="bttn bttn--lg bttn--orange" @click="send" :disabled="loading">
          <b-spinner v-if="loading" small></b-spinner>
          {{ btnTitle }}
        </button>

        <span class="tw-ml-2 tw-text-sm tw-text-orange-700">
          {{ $t("dashboard.resubscribe_description", "Re-subscribe") }}
        </span>
      </div>

      <b-alert v-else variant="success" show>
        {{
          $t(
            "dashboard.resubscribe_success",
            "New subscription(ID: {new_subscription_id}) created for {remaining} {period} ",
            { ...result, period: result.remaining === 1 ? result.period : result.period + "s" }
          )
        }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls";
import { notificationsMixin } from "@/mixins";

export default {
  props: {
    donationID: {
      type: [Number, String],
      default: 0,
    },
    donationAttributes: {
      type: Object,
      default: () => {},
    },
  },

  mixins: [notificationsMixin],

  data() {
    return {
      success: false,
      loading: false,
      result: {
        duration: 0,
        success_charges: 0,
        remaining: 0,
        new_subscription_id: "",
        period: "",
      },
    };
  },

  computed: {
    orgId() {
      return localStorage.getItem("orgId");
    },
    btnTitle() {
      return this.$t("dashboard.resubscribe", "Re-subscribe");
    },
  },

  methods: {
    send() {
      let message = this.$t("dashboard.resubscribe_confirm_msg", "Re-subscribe");

      let options = {
        okText: this.$t("dashboard.confirm_ok_btn", "Ok"),
        cancelText: this.$t("edit_campaign.confirm_cancel", "Cancel"),
      };

      this.$dialog.confirm(message, options).then(() => {
        this.loading = true;
        axios
          .post(
            urls.recurringDonationResubscribe
              .replace(":oid", this.orgId)
              .replace(":cid", this.donationAttributes.campaign_id)
              .replace(":did", this.donationID)
          )
          .then(({ data }) => {
            this.$_notificationsMixin_makeToast("Success", "", "success");
            this.success = true;
            this.result = data.data;
          })
          .catch((e) => {
            this.$_notificationsMixin_handleCatch(e);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.action-block {
  @apply tw-flex tw-items-center tw-w-full;
  @apply tw-p-6 tw-m-4 tw-border-2 tw-rounded-2xl tw-border-orange-300;
}
</style>
